import { render, staticRenderFns } from "./ShiftStatusAlerts.vue?vue&type=template&id=f5fff346&"
import script from "./ShiftStatusAlerts.vue?vue&type=script&setup=true&lang=js&"
export * from "./ShiftStatusAlerts.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports